import React from 'react';
import PropTypes from 'prop-types';

Item.propTypes = {
  /** The renderable badge value or element. */
  badge: PropTypes.node,

  /** The text label for the tab */
  label: PropTypes.string.isRequired,

  /** The small sub text for the tab */
  subText: PropTypes.string,

  /** Mark item selected. If omitted and the panel is not controlled, the first tab will be selected by default. */
  selected: PropTypes.bool,

  /** The content to show for this tab item */
  children: PropTypes.any,
};

/**
 * **Access:**
 * ```js
 * import {Tabs} from '@iss/client-react-components'
 *
 * <Tabs.Item ... />
 *
 * ```
 * Represents a tab in a tab panel. This is just a wrapper component the provides a place to configure the tab and
 * content under one place.
 *
 * @component
 */
export default function Item({ children }) {
  return <React.Fragment children={children} />;
}
